export function getLanguageOptions(localized) {
  return [
    {
      label: (localized && localized['language.en-US']) || 'English',
      value: 'en-US'
    },
    {
      label: (localized && localized['language.fr-CA']) || 'French',
      value: 'fr-CA'
    }
  ];
}
